import React from 'react';
import { Link } from 'react-router-dom';
import './AutomationCard.css';

const AutomationCard = ({ automation, onDelete, onToggle }) => {
  const { id, name, description, active, lastTriggered, conditions, actions } = automation;

  // Format the last triggered date
  const formatLastTriggered = () => {
    if (!lastTriggered) return 'Never triggered';
    
    const date = new Date(lastTriggered);
    return date.toLocaleString();
  };

  return (
    <div className={`automation-card ${active ? 'active' : 'inactive'}`}>
      <div className="automation-card-header">
        <h3>{name}</h3>
        <div className="automation-card-controls">
          <label className="toggle-switch">
            <input 
              type="checkbox" 
              checked={active} 
              onChange={() => onToggle && onToggle(id)}
            />
            <span className="toggle-slider"></span>
          </label>
          <button 
            className="delete-btn"
            onClick={() => onDelete && onDelete(id)}
            aria-label="Delete automation"
          >
            ×
          </button>
        </div>
      </div>
      
      <p className="automation-card-description">
        {description || 'No description'}
      </p>
      
      <div className="automation-card-stats">
        <div className="stat">
          <span className="stat-label">Conditions:</span>
          <span className="stat-value">{conditions?.length || 0}</span>
        </div>
        <div className="stat">
          <span className="stat-label">Actions:</span>
          <span className="stat-value">{actions?.length || 0}</span>
        </div>
      </div>
      
      <div className="automation-card-footer">
        <div className="last-triggered">
          <span className="stat-label">Last triggered:</span>
          <span className="stat-value">{formatLastTriggered()}</span>
        </div>
        <Link to={`/automations/${id}`} className="edit-link">
          Edit
        </Link>
      </div>
    </div>
  );
};

export default AutomationCard;